@if (config().link; as link) {
  <app-abstract-link [config]="link" [ariaLabel]="config().ariaLabel" (clicked)="onClicked()">
    <div [class]="classes()">
      <app-fa-icon [config]="identity().icon" />
    </div>
  </app-abstract-link>
}
